import { IToggleInputProps } from "../../utils/interfaces";

const AppToggleInput = ({
  value,
  onChange,
  label,
}: IToggleInputProps) => {
  const handleClick = () => {
    onChange(!value);
  };

  return (
    <div className={`w-full  flex  items-start gap-2 font-semibold `}>
      <span>{label}</span>

      <button
        type="button"
        onClick={handleClick}
        className={`w-14 h-8 flex items-center rounded-full p-1 cursor-pointer transition-colors duration-300 ${
          value ? "bg-primary-yellowLight" : "bg-gray-300"
        }`}
      >
        <div
          className={`bg-white w-6 h-6 rounded-full shadow-md transform transition-transform duration-300 ${
            value ? "translate-x-6" : "translate-x-0"
          }`}
        />
      </button>
    </div>
  );
};

export default AppToggleInput;
